/**
 * Add your action types here.
 * @module constants/ActionTypes
 * @example
 * export const UPDATE_CONTENT = 'UPDATE_CONTENT';
 */
export const GET_CONTACT_INFO = 'GET_CONTACT_INFO';
export const POST_CONTACT_INFO = 'POST_CONTACT_INFO';
export const GET_CATEGORIES = 'GET_CATEGORIES';
export const POST_GOVBR_SERVICES = 'POST_GOVBR_SERVICES';
